module.exports = __webpack_public_path__ + "static/img/partner-qx.bde1a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-qx.png
// module id = aXfW
// module chunks = 34